import { useActiveStoreCatalog } from '../../store/selectors/menu';
/* eslint-disable no-lone-blocks */
import React from "react";
import { useState, useEffect } from "react";
import { Grid, Typography, Box, Divider, Button, TextField, IconButton } from "@material-ui/core";
import defaultimg from "../../assets/images/default.png";
import VegIcon from "../../assets/images/Veg Icon 1.svg";
import NonVegIcon from "../../assets/images/Non Veg Icon 1.svg";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Modal from "@mui/material/Modal";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Drawer from "@mui/material/Drawer";
import { BUTTON_COLOR, TEXT_COLOR } from "../../utils/constant";
import ListAddItemButton from "../../components/ListAddItemButton";
import SuggestedItemButton from "../../components/SuggestedItemButton";
import ItemModifier from "../../components/Modifier";
import Repeatation from "../../components/Repeatation";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  borderRadius: "1rem",

  p: 1,
};

export default function CartItems(props) {
  const {
    addedItems,
    currency,
    storeInfo,storeInfoConfig,
    item_list,
    reducer,
    allitem,
    itemVerriantList,
    openInventory,
    setOpenInventory,
    arr,
    inventoryData,
  } = props;

  const [suggestItemList, setSuggestItemList] = useState([]);
  const [showMoreAddons, setShowMoreAddons] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);
  const [modifierPopup, setModifierPopup] = useState(false);
  const [isRepeatation, setIsRepeatation] = useState(false);
  const [action, setAction] = React.useState(0);
  const [openSpecialRequest, setOpenSpecialRequest] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [tempSpecialRequestText, setTempSpecialRequestText] = useState("");

  const stores = props.sessionReducer?.associated_stores;

  let primaryColor =  storeInfoConfig?.general_config?.primary_color;
  let secondaryColor =  storeInfoConfig?.general_config?.secondary_color;

  const removeItem = (item) => {
    props.subtractQuantity(item);
  };

  const addItem = (item) => {
    props.addQuantity(item);
  };

  const handleOpenSpecialRequest = (item) => {
    setEditingItem(item);
    setTempSpecialRequestText(item.specialRequest || "");
    setOpenSpecialRequest(true);
  };

  const handleSaveSpecialRequest = () => {
    if (editingItem) {
      if (props.updateItemSpecialRequest) {
        props.updateItemSpecialRequest(editingItem.itemUniqueId, tempSpecialRequestText);
      }
    }
    setOpenSpecialRequest(false);
    setEditingItem(null);
    setTempSpecialRequestText("");
  };

  function sumArray(arr) {
    let sum = 0;
    for (let i = 0; i < arr.length; i++) {
      sum += arr[i];
    }
    return sum;
  }

  const groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  const ItemGroupByStore = groupBy(addedItems.filter(i => !i.is_void && !i.isVoid && !i.is_refund), "store_id");

  const getMergeKey = (item) => {
    const skus = [];
    if (item?.item_variant?.[0]?.sku) skus.push(item.item_variant[0].sku);
    const addons = item?.selected_addons_items || item?.selectedAddonsItems || [];
    addons.forEach((a) => a?.sku && skus.push(a.sku));
    skus.sort();
    const modKey = JSON.stringify(item?.selected_modifier || item?.selectedModifier || []);
    return `${item?._id || ""}|${item?.variant_name || ""}|${skus.join(",")}|${modKey}|${item?.specialRequest || ""}`;
  };

  const mergeStoreItems = (items) => {
    const groups = new Map();
    items.forEach((item, originalIndex) => {
      const key = getMergeKey(item);
      if (!groups.has(key)) {
        groups.set(key, { representative: item, lines: [], originalIndex });
      }
      groups.get(key).lines.push(item);
    });
    return Array.from(groups.values()).map((g) => {
      const totalQty = g.lines.reduce((a, l) => a + (l.quantity || 0), 0);
      const totalSubTotal = g.lines.reduce((a, l) => a + (l.sub_total || 0), 0);
      const totalDiscount = g.lines.reduce((a, l) => a + (l.discount_amount || l.total_discount || 0), 0);
      const discountedLines = g.lines.filter((l) => (l.discount_amount || l.total_discount || 0) > 0);
      const fullPriceLine = g.lines.find((l) => !(l.discount_amount || l.total_discount || 0)) || g.lines[0];
      const discountedQty = discountedLines.reduce((a, l) => a + (l.quantity || 0), 0);
      return {
        ...g.representative,
        quantity: totalQty,
        sub_total: totalSubTotal,
        _merged: {
          lines: g.lines,
          fullPriceLine,
          discountedQty,
          totalDiscount,
        },
      };
    });
  };

  const getStoreName = function (store_id) {
    const store = props.sessionReducer?.associated_stores?.find(
      (e) => e.store_id === store_id
    );
    return store?.store_name;
  };

  const getStoreLogo = function (store_id) {
    const store = props.sessionReducer?.associated_stores?.find(
      (e) => e.store_id === store_id
    );
    return store?.store_logo || storeInfo?.store_display_logo || defaultimg;
  };

  const checkInventory = (sku) => {
    const inventory = inventoryData?.find((e) => e?.sku === sku);
    if (
      // inventory?.inventory_quantity == null ||
      inventory?.inventory_quantity > 5
    ) {
      return false;
    }
    return true;
  };

  const suggestItemsSku = () => {
    let skuSet = new Set();

    addedItems.forEach((e) => {
      let items = e?.suggested_list || [];
      items.forEach((sku) => skuSet.add(sku));
    });

    const uniqueSkus = Array.from(skuSet);
    const addedSkus = new Set((addedItems || []).map((i) => String(i.sku || i._id)));

    const filteredItems = item_list?.filter(
      (item) =>
        uniqueSkus.includes(item.sku) &&
        !addedSkus.has(String(item.sku)) &&
        !addedSkus.has(String(item._id))
    );

    setSuggestItemList(filteredItems);
  };

  React.useEffect(() => {
    suggestItemsSku();
  }, [addedItems, item_list]);

  const SuggestItems = () => {
    return (
      <Grid style={{ margin: "0.5rem", width: "100%" }}>
        <div
          style={{
            display: "flex",
            overflowX: "auto",
            gap: "1rem",
            scrollbarWidth: "none",
          }}
        >
          {suggestItemList?.length
            ? suggestItemList.map((e, index) => (
                <div
                  key={index}
                  style={{
                    minWidth: "190px",
                    background: "#fff",
                    padding: "0.75rem" ,
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                    border: "1px solid #eee",
                    display: "flex",
                    minHeight:"22vh",
                    
                    maxHeight:"22vh",
                    flexDirection: "column",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  {/* Veg/Non-Veg Icon - Top left corner */}
                  {(() => {
                    const d = e?.dietary?.toLowerCase()?.trim();
                    const isVeg = d === "veg";
                    const isNonVegOrEgg = d === "non-veg" || d === "nonveg" || d === "non veg" || d === "non_veg" || d === "egg" || d === "eggetarian" || d === "eggiterian" || d === "eggitarian";
                    if (!isVeg && !isNonVegOrEgg) return null;
                    return (
                      <img
                        src={isVeg ? VegIcon : NonVegIcon}
                        alt={isVeg ? "Veg" : "Non-Veg"}
                        style={{
                          position: "absolute",
                          top: 10,
                          left: 8,
                          width: 16,
                          height: 16,
                          zIndex: 1,
                        }}
                      />
                    );
                  })()}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      maxHeight: "90px",
                      overflow: "hidden",
                      borderTopLeftRadius: "8px",
                      borderTopRightRadius: "8px",
                    }}
                  >
                    <img
                      src={e?.item_display_img || defaultimg}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  {/* Content */}
                  <div style={{ 
 
 position: "absolute",
 minWidth: "90%",
 bottom: 0,
 paddingBottom: "0.75rem" ,
                  }}>
                    {/* Title */}
                    <Typography
                      style={{
                        textAlign: "left",
                        fontWeight: "700",
                        textTransform: "capitalize",
                        overflow: "hidden",
                      }}
                      title={e?.item_name}
                    >
                      <span style={{ fontSize: "16px" }}> {e?.item_name}</span>
                    </Typography>

                    {/* Price and ADD button */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "0.5rem",
                      }}
                    >
                      <Typography
                        style={{
                          fontWeight: "bold",
                          fontSize: "14px",
                          color: "#333",
                        }}
                      >
                        {" "}
                        <span style={{ fontSize: "14px" }}>
                          {currency}{" "}
                          {e?.item_variant?.length
                            ? parseFloat(e?.item_variant[0]?.plu || 0).toFixed(2)
                            : "0.00"}{" "}
                        </span>
                      </Typography>

                      {/* Add Button */}
                      <SuggestedItemButton
                        {...{
                          lineItem: e,
                          setSelectedItem,
                          setModifierPopup,
                          setIsRepeatation,
                          storeInfo,
                          setAction,storeInfoConfig,
                          checkInventory: checkInventory(e),
                        }}
                        style={{
                          fontSize: "12px",
                          background: "#FF3366",
                          color: "#fff",
                          borderRadius: "16px",
                          padding: "4px 10px",
                          minWidth: "auto",
                          textTransform: "uppercase",
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))
            : null}
        </div>
      </Grid>
    );
  };

  const OutStockItems = () => {
    return arr?.length
      ? arr.map((e) => {
          return (
            <>
              <Grid
                container
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                  background: "white",
                  padding: "0.5rem 1rem",
                  // borderBottom: "1px solid #eeeeee",
                }}
              >
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Grid
                    container
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    justifyContent="space-between"
                  >
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <Typography
                        style={{ fontWeight: "bold", textAlign: "left" }}
                      >
                        {e?.item_variant[0]?.item_name || "NA"}
                      </Typography>
                    </Grid>

                    <Grid item xs={1} sm={1} md={1} lg={1}>
                      <Typography
                        style={{
                          fontWeight: "bold",

                          display: "flex",
                          alignContent: "center",
                          justifyContent: "flex-end",
                          alignItems: "center",
                        }}
                      >
                        <CloseRoundedIcon style={{ height: "14px" }} />
                        {e?.quantity || "0"}
                      </Typography>
                    </Grid>

                    <Grid item xs={3} sm={3} md={3} lg={3}>
                      <Typography
                        style={{ fontWeight: "bold", textAlign: "right" }}
                      >
                        {currency}{" "}
                        {e?.total_net_sale
                          ? e.total_net_sale.toFixed(2)
                          : "0.00"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </>
          );
        })
      : "";
  };

  return (
    <>
      <Grid
        container
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          paddingRight: "6%",
          paddingLeft: "3%",
          paddingTop: "2%",
          paddingBottom: "2%",
        }}
      >
        {(addedItems?.length &&
          Object.keys(ItemGroupByStore).map(function (store_id) {
            const mergedStoreItems = mergeStoreItems(ItemGroupByStore[store_id]);
            return (
              <Grid
                style={{
                  margin: "0.5rem",
                  minWidth: "100%",
                  borderRadius: "8px",
                }}
              >

                {(() => {
                  const groupQty = mergedStoreItems.reduce((acc, t) => acc + (t.quantity || 0), 0);
                  const storeGroupTotal = mergedStoreItems.reduce((acc, t) => acc + (t.sub_total || 0), 0);
                  return (
                    <Grid
                      container
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "0.5rem 0rem",
                        marginBottom: "0.2rem",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {/* Store Logo Square Container */}
                        <div
                          style={{
                            width: "48px",
                            height: "48px",
                            borderRadius: "8px",
                            border: "1px solid #f0f0f0",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "white",
                            boxShadow: "rgba(12, 26, 75, 0.03) 0px 2px 4px 0px",
                          }}
                        >
                          <img
                            alt="Store Logo"
                            style={{
                              maxWidth: "85%",
                              maxHeight: "85%",
                              width: "auto",
                              height: "auto",
                              objectFit: "contain",
                              borderRadius: "4px",
                            }}
                            src={getStoreLogo(store_id)}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = defaultimg;
                            }}
                          />
                        </div>

                        {/* Store Name and Quantity */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginLeft: "12px",
                          }}
                        >
                          <Typography
                            style={{
                              fontFamily: "satoshi, Mulish, sans-serif",
                              fontWeight: "700",
                              fontSize: "15px",
                              color: "#2C3E50",
                              textAlign: "left",
                            }}
                          >
                            {getStoreName(store_id)}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: "satoshi, Mulish, sans-serif",
                              fontWeight: "500",
                              fontSize: "13px",
                              color: "#7F8C8D",
                              textAlign: "left",
                              marginTop: "2px",
                            }}
                          >
                            {groupQty} {groupQty > 1 ? "Items" : "Item"}
                          </Typography>
                        </div>
                      </div>

                      {/* Total for this store */}
                      <div>
                        <Typography
                          style={{
                            fontFamily: "satoshi, Mulish, sans-serif",
                            fontWeight: "700",
                            fontSize: "16px",
                            color: primaryColor || BUTTON_COLOR,
                          }}
                        >
                          {currency}{" "}
                          {parseFloat(storeGroupTotal || 0).toFixed(2)}
                        </Typography>
                      </div>
                    </Grid>
                  );
                })()}

                <Grid
                  style={{
                    background: "white",
                    padding: "1rem 1rem",
                    borderRadius: "8px",
                    margin: "0.5rem 0rem",
                    boxShadow: "#0000001F 0px 0px 4px 0px",
                    // box-shadow: 0px 0px 4px 0px #0000001F;

                  }}
                >
                  {mergedStoreItems.map((t, tIndex, storeItems) => {
                    const addonNames = [];
                    const variantName = t?.item_variant?.[0]?.variant_name;
                    const isVoidedOrRefunded =
                      t?.is_void === true ||
                      t?.isVoid === true ||
                      t?.is_refund === true;
                    if (variantName && variantName.toLowerCase() !== "regular") {
                      addonNames.push(variantName);
                    }

                    const selectedMods = t?.selected_modifier || t?.selectedModifier || [];
                    selectedMods.forEach((group) => {
                      if (Array.isArray(group?.modifiers)) {
                        group.modifiers.forEach((m) => {
                          const name = m?.modifier_name || m?.name;
                          if (name) addonNames.push(name);
                        });
                      } else if (group?.modifier_name || group?.name) {
                        addonNames.push(group?.modifier_name || group?.name);
                      }
                    });

                    const addonsList = Array.isArray(t?.selectedAddonsItems)
                      ? t.selectedAddonsItems
                      : Array.isArray(t?.selected_addons_items)
                      ? t.selected_addons_items
                      : Array.isArray(t?.subItems)
                      ? t.subItems
                      : [];

                    addonsList.forEach((e) => {
                      const iName = (e?.item_name || e?.name || e?.item_variant?.[0]?.item_name || "").replace(/\s*Regular\b/gi, "").trim();
                      if (iName) {
                        addonNames.push(iName);
                      }
                    });
                    const allAddonsText = addonNames.join(", ");
                    const maxAddonsLength = 40;
                    const isLong = allAddonsText.length > maxAddonsLength;
                    const key = `${store_id}-${tIndex}`;
                    const showAll = showMoreAddons[key];
                    const addonsText = isLong && !showAll
                      ? allAddonsText.slice(0, maxAddonsLength)
                      : allAddonsText;

                    const toggleShowMore = () => {
                      setShowMoreAddons((prev) => ({
                        ...prev,
                        [key]: !prev[key],
                      }));
                    };

                    const itemDiscountInfo = (() => {
                      const engineDiscount = props.cartProps?.engineDiscount;
                      const origPrice = parseFloat(t?.sub_total || 0);
                      if (!engineDiscount || !(engineDiscount.total_discount > 0)) {
                        return { discount: 0, origPrice, finalPrice: origPrice, isFree: false, isDiscounted: false, discountedQty: 0 };
                      }
                      const engineItems = (engineDiscount.item_details || []).filter((ei) => !ei.main_item_id);
                      const itemSku = String(t?.item_variant?.[0]?.sku || t?.sku || "");
                      const itemId = String(t?._id || t?.item_id || t?.id || "");
                      const itemVariant = String(t?.variant_name || "");
                      // Addon signature disambiguates display rows that share
                      // _id/sku/variant but differ by addon selection (e.g.
                      // Strawberry Sundae + Coffee vs Strawberry Sundae + Lemonade).
                      // Without this, both display groups sum every matching
                      // engine row and both show the same discount.
                      const addonSig = (list) => (list || [])
                        .map((a) => String(a?._id || a?.sku || a?.item_name || ""))
                        .sort()
                        .join(",");
                      const displayAddonSig = addonSig(t?.selectedAddonsItems || t?.selected_addons_items);
                      const matches = engineItems.filter((ei) => {
                        const eiId = String(ei._id || ei.item_id || "");
                        const eiSku = String(ei.sku || ei.item_variant?.[0]?.sku || "");
                        const eiVariant = String(ei.variant_name || "");
                        const idMatch = itemId && eiId && itemId === eiId;
                        const skuMatch = itemSku && eiSku && itemSku === eiSku;
                        if (!(idMatch || skuMatch)) return false;
                        if (itemVariant && eiVariant && itemVariant !== eiVariant) return false;
                        if (addonSig(ei?.selectedAddonsItems || ei?.selected_addons_items) !== displayAddonSig) return false;
                        return true;
                      });
                      const discount = matches.reduce(
                        (a, m) => a + parseFloat(m?.discount_amount || m?.total_discount || 0),
                        0
                      );
                      const discountedQty = matches
                        .filter((m) => parseFloat(m?.discount_amount || m?.total_discount || 0) > 0)
                        .reduce((a, m) => a + parseFloat(m?.quantity || 0), 0);
                      const finalPrice = Math.max(0, origPrice - discount);
                      const isFree = discount > 0 && finalPrice === 0;
                      return {
                        discount,
                        origPrice,
                        finalPrice,
                        isFree,
                        isDiscounted: discount > 0,
                        discountedQty,
                      };
                    })();

                    const editableLine = t?._merged?.fullPriceLine || t;

                    return (
                      <React.Fragment key={tIndex}>
                      <Grid container>
                        <Grid
                          container
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          style={{
                            margin: "0.5rem 0rem",
                          }}
                        >
                          <Grid
                            item
                            xs={3}
                            sm={3}
                            md={3}
                            lg={3}
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            <div style={{ position: "relative", width: "90px", height: "65px" }}>
                              {(() => {
                                const d = t?.dietary?.toLowerCase()?.trim();
                                const isVeg = d === "veg";
                                const isNonVegOrEgg = d === "non-veg" || d === "nonveg" || d === "non veg" || d === "non_veg" || d === "egg" || d === "eggetarian" || d === "eggiterian" || d === "eggitarian";
                                if (!isVeg && !isNonVegOrEgg) return null;
                                return (
                                  <img
                                    src={isVeg ? VegIcon : NonVegIcon}
                                    alt={t?.dietary}
                                    style={{
                                      position: "absolute",
                                      top: "4px",
                                      left: "4px",
                                      width: "14px",
                                      height: "14px",
                                      objectFit: "contain",
                                      zIndex: 2,
                                    }}
                                  />
                                );
                              })()}
                              <img
                                alt="Logo"
                                width="100%"
                                style={{
                                  width: "70px",
                                  height: "65px",
                                  borderRadius: "8px",
                                  objectFit: t?.item_display_img ? "cover" : "contain"
                                }}
                                src={t?.item_display_img || defaultimg}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = defaultimg;
                                }}
                              />
                            </div>
                          </Grid>

                          <Grid
                            item
                            xs={9}
                            sm={9}
                            md={9}
                            lg={9}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "flex-start",
                              paddingLeft: "12px",
                            }}
                          >
                            {/* Left Side: Item Details */}
                            <div style={{ display: "flex", flexDirection: "column", flex: 1, paddingRight: "8px" }}>
                              <Typography
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "left",
                                  fontSize: "15px",
                                  fontFamily: "Satoshi",
                                  color: isVoidedOrRefunded ? "#999999" : "#333",
                                  textDecoration: isVoidedOrRefunded ? "line-through" : "none",
                                }}
                              >
                               <span style={{fontSize:"15px"}}>{t?.item_name || "NA"}</span>
                              </Typography>

                              {/* Variant details / Addons */}
                              <div style={{ textAlign: "left", marginTop: "6px" }}>
                                {/* Addons */}
                                {addonsText && (
                                  <div style={{
                                    fontFamily: "Satoshi",
                                    fontSize: "14px",
                                    color: isVoidedOrRefunded ? "#b0b0b0" : "#999999",
                                    lineHeight: "1.3",
                                    textDecoration: isVoidedOrRefunded ? "line-through" : "none",
                                  }}>
                                    {addonsText}
                                    {isLong && (
                                      <span
                                        style={{ color: primaryColor || "#2B6CB0", cursor: "pointer", fontWeight: "600" }}
                                        onClick={toggleShowMore}
                                      >
                                        {showAll ? " less" : "...more"}
                                      </span>
                                    )}
                                  </div>
                                )}
                              </div>

                              {/* Price placement */}
                              <div style={{ textAlign: "left", marginTop: "6px" }}>
                                <Typography
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontWeight: "700",
                                    fontSize: "16px",
                                    color: isVoidedOrRefunded ? "#999999" : (itemDiscountInfo.isFree ? "#2E7D32" : (primaryColor || BUTTON_COLOR)),
                                    textDecoration: isVoidedOrRefunded ? "line-through" : "none",
                                  }}
                                >
                                  {itemDiscountInfo.isDiscounted ? (
                                    <>
                                      <span style={{ fontSize: "13px", textDecoration: "line-through", color: "#999", marginRight: "6px" }}>
                                        {currency}{" "}
                                        {itemDiscountInfo.origPrice.toFixed(2)}
                                      </span>
                                      <span style={{ fontSize: "16px", color: isVoidedOrRefunded ? "#999999" : (itemDiscountInfo.isFree ? "#2E7D32" : (primaryColor || BUTTON_COLOR)) }}>
                                        {itemDiscountInfo.isFree ? "FREE" : `${currency} ${itemDiscountInfo.finalPrice.toFixed(2)}`}
                                      </span>
                                    </>
                                  ) : (
                                    <span>
                                      {currency}{" "}
                                      {itemDiscountInfo.origPrice.toFixed(2)}
                                    </span>
                                  )}
                                </Typography>
                                {itemDiscountInfo.isDiscounted && !isVoidedOrRefunded && (
                                  <div style={{ marginTop: "4px" }}>
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "3px",
                                        backgroundColor: itemDiscountInfo.isFree ? "#E8F5E9" : `${primaryColor || BUTTON_COLOR}15`,
                                        color: itemDiscountInfo.isFree ? "#2E7D32" : (primaryColor || BUTTON_COLOR),
                                        borderRadius: "4px",
                                        padding: "2px 6px",
                                        fontSize: "11px",
                                        fontWeight: "700",
                                        fontFamily: "Satoshi",
                                      }}
                                    >
                                      {itemDiscountInfo.isFree ? "🎉 FREE with Coupon" : "🏷️ Discount Applied"}
                                    </span>
                                  </div>
                                )}
                              </div>

                              {/* Special Request Row */}
                              <div 
                                onClick={() => handleOpenSpecialRequest(t)}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "6px", 
                                  color: t?.specialRequest ? "#333" : "#888",
                                  gap: "6px",
                                  cursor: "pointer",
                                  userSelect: "none",
                                }}
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 14 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  style={{ flexShrink: 0 }}
                                >
                                  <path
                                    d="M13.7682 1.962L12.0116 0.22213C11.8606 0.0795438 11.66 0 11.4513 0C11.2427 0 11.0421 0.0795438 10.8911 0.22213L9.32914 1.7739H0.94953C0.697699 1.7739 0.456182 1.87299 0.278111 2.04936C0.100039 2.22573 0 2.46494 0 2.71437V13.0595C0 13.309 0.100039 13.5482 0.278111 13.7245C0.456182 13.9009 0.697699 14 0.94953 14H11.3944C11.6462 14 11.8877 13.9009 12.0658 13.7245C12.2439 13.5482 12.3439 13.309 12.3439 13.0595V4.48245L13.7682 3.07175C13.9166 2.92451 14 2.72495 14 2.51687C14 2.3088 13.9166 2.10924 13.7682 1.962ZM7.04077 8.41832L5.0515 8.85563L5.52627 6.90416L10.0603 2.40402L11.5938 3.92287L7.04077 8.41832ZM12.1065 3.38681L10.573 1.86795L11.4513 0.998017L12.9848 2.51687L12.1065 3.38681Z"
                                    fill={primaryColor || "#3159A6"}
                                  />
                                </svg>
                                <span style={{ 
                                  fontFamily: "Satoshi", 
                                  fontSize: "13px", 
                                  fontWeight: "600", 
                                  color: t?.specialRequest ? "#333" : "#888", 
                                  wordBreak: "break-word", 
                                  textAlign: "left", 
                                  lineHeight: "1.4",
                                  textDecoration: t?.specialRequest ? "none" : "none"
                                }}>
                                  {t?.specialRequest ? t.specialRequest : "Special Request"}
                                </span>
                              </div>
                            </div>

                            {/* Right Side: Quantity Selector */}
                            <div style={{ display: "flex", flexDirection: "column", flexShrink: 0 }}>
                              <div
                                style={{
                                  display: "flex",
                                  padding: "2px 6px",
                                  justifyContent: "space-evenly",
                                  alignContent: "center",
                                  alignItems: "center",
                                  minWidth: "5.5rem",
                                  borderRadius: "6px",
                                  backgroundColor: primaryColor || BUTTON_COLOR,
                                  boxShadow: "none",
                                  height: "30px",
                                }}
                              >
                                <Grid container justifyContent="center" alignItems="center" xs={4} sm={4} md={4} lg={4}>
                                  <RemoveIcon
                                    style={{
                                      color: "#ffffff",
                                      fontSize: "18px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => removeItem(editableLine)}
                                  />
                                </Grid>
                                <Grid xs={4} sm={4} md={4} lg={4} style={{ display: "flex", justifyContent: "center" }}>
                                  <Typography>
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        fontFamily: "Satoshi",
                                        color: "#ffffff",
                                        fontWeight: "700",
                                      }}
                                    >
                                      {t?.quantity || 0}
                                    </span>
                                  </Typography>
                                </Grid>
                                <Grid container justifyContent="center" alignItems="center" xs={4} sm={4} md={4} lg={4}>
                                  <AddIcon
                                    style={{
                                      color: "#ffffff",
                                      fontSize: "18px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => addItem(editableLine)}
                                  />
                                </Grid>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                      {tIndex < storeItems.length - 1 && (
                        <div
                          style={{
                            width: "100%",
                            height: "1px",
                            backgroundColor: "#EEEEEE",
                            margin: "0.25rem 0",
                          }}
                        />
                      )}
                      </React.Fragment>
                    );
                  })}
                </Grid>
              </Grid>
            );
          })) ||
          ""}
        <Modal
          open={openInventory}
          onClose={() => setOpenInventory(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography style={{ padding: "1rem", textAlign: "center" }}>
              <span style={{ fontSize: "1.1rem" }}>
                Some Items in Your Cart are Out of stock.
                <br />
                <span style={{ fontSize: "1rem" }}>
                  Try to reduce quantity or change the items.
                </span>
              </span>
            </Typography>
            <Divider></Divider>
            <OutStockItems />
          </Box>
        </Modal>

        <Drawer
          open={openSpecialRequest}
          anchor="bottom"
          onClose={() => {
            setOpenSpecialRequest(false);
            setEditingItem(null);
            setTempSpecialRequestText("");
          }}
          PaperProps={{
            style: {
              borderTopLeftRadius: "24px",
              borderTopRightRadius: "24px",
              padding: "1.5rem",
              backgroundColor: "#ffffff",
              boxShadow: "0px -4px 20px rgba(0, 0, 0, 0.08)",
            }
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingBottom: "1rem",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <Typography
              style={{
                fontFamily: "Satoshi",
                fontSize: "18px",
                fontWeight: "700",
                color: primaryColor || BUTTON_COLOR,
              }}
            >
              Special Request for {editingItem?.item_name}
            </Typography>
            <IconButton
              onClick={() => {
                setOpenSpecialRequest(false);
                setEditingItem(null);
                setTempSpecialRequestText("");
              }}
              style={{ padding: "4px" }}
            >
              <CloseRoundedIcon style={{ color: primaryColor || BUTTON_COLOR }} />
            </IconButton>
          </div>

          {/* Body Input Box */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: `1.5px solid ${primaryColor || BUTTON_COLOR}`,
              borderRadius: "10px",
              padding: "12px 16px",
              marginTop: "1.5rem",
              marginBottom: "1.5rem",
              backgroundColor: "#ffffff",
            }}
          >
            <input
              type="text"
              placeholder="e.g. Dont make it too spicy"
              value={tempSpecialRequestText || ""}
              onChange={(e) => setTempSpecialRequestText(e.target.value)}
              style={{
                flex: 1,
                border: "none",
                outline: "none",
                fontSize: "15px",
                fontFamily: "Satoshi",
                color: "#333",
              }}
            />
            {/* Blue Tilted Pencil SVG Icon */}
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ flexShrink: 0 }}
            >
              <path
                d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z"
                fill={primaryColor || BUTTON_COLOR}
              />
            </svg>
          </div>

          {/* Footer Buttons */}
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => {
                  setOpenSpecialRequest(false);
                  setEditingItem(null);
                  setTempSpecialRequestText("");
                }}
                style={{
                  borderColor: primaryColor || BUTTON_COLOR,
                  color: primaryColor || BUTTON_COLOR,
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: "700",
                  fontFamily: "Satoshi",
                  fontSize: "16px",
                  padding: "10px 0px",
                  borderWidth: "1.5px",
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant="contained"
                disableElevation
                onClick={handleSaveSpecialRequest}
                style={{
                  backgroundColor: primaryColor || BUTTON_COLOR,
                  color: "#ffffff",
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: "700",
                  fontFamily: "Satoshi",
                  fontSize: "16px",
                  padding: "10px 0px",
                  boxShadow: "none",
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Drawer>

        {suggestItemList?.length ? (
          <>
            <Typography
              variant="h5"
              style={{ fontWeight: "bold", marginLeft: "0.5rem" }}
            >
              <span style={{ fontSize: "16px", textAlign: "left" }}>
                {" "}
                Based on your choice, you might also like
              </span>
            </Typography>
            <SuggestItems />
          </>
        ) : (
          ""
        )}

        <ItemModifier
          style={{ minWidth: "20rem" }}
          {...props}
          {...{
            modifierPopup,
            setModifierPopup,
            selectedItem,
            setSelectedItem,
            allitem,
            itemVerriantList,
            // addonList,
            currency,
          }}
        />
        <Repeatation
          {...props}
          {...{
            isRepeatation,
            setIsRepeatation,
            selectedItem,
            setSelectedItem,
            setModifierPopup,
            action,
          }}
        />
        {/* {(addedItems?.length &&
          addedItems.map((e) => {
            return (
              <>
              <Grid container
              style={{   marginTop:"1rem",    border:"1px solid black"}}>

         
              <Grid 
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12} style={{
                    background: BUTTON_COLOR,
                    padding: "0.3rem",
             
                  }} >
              <Typography style={{color:TEXT_COLOR}}>{e.store_id}</Typography>
              </Grid>
            
                <Grid
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    background: "white",
                    padding: "0.5rem",
                  }}
                >
                  <Grid
                    item
                    xs={3}
                    sm={3}
                    md={3}
                    lg={3}
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <img
                      alt="Logo"
                      width="100%"
                      style={{width:"70px",height:"65px"}}
                      src={e?.item_display_img || defaultimg}
                    />
                  </Grid>

                  <Grid item xs={9} sm={9} md={9} lg={9}>
                    <Grid
                      container
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      justifyContent="space-between"
                    >
                      <Grid item xs={9} sm={9} md={9} lg={9}>
                        <Typography
                          style={{ fontWeight: "bold", textAlign: "left" }}
                        >
                          {e?.item_name || "NA"}
                        </Typography>
                      </Grid>

                      <Grid item xs={3} sm={3} md={3} lg={3}>
                        <Typography
                          style={{ fontWeight: "bold", textAlign: "right" }}
                        >
                          {currency}{" "}
            

                          {e?.total_net_sale
                            ? e.total_net_sale.toFixed(2)
                            : "0.00"}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs={9}
                      sm={9}
                      md={9}
                      lg={9}
                      style={{
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Typography
                        style={{
                          textAlign: "left",
                          color: "#808080c7",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {e?.description || "NA"}
                      </Typography>
                    </Grid>
                    <Grid
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      style={{
                        display: "flex",
                      }}
                    >
                      <Grid container xs={10} sm={10} md={10} lg={10}>
                        {e?.item_variant[0].variant_name}
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        sm={2}
                        md={2}
                        lg={2}
                        style={{
                          float: "right",
                          display: "flex",
                          boxShadow:
                            "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
                          justifyContent: "space-evenly",
                          alignContent: "center",
                          alignItems: "center",
                          border: "0.5px solid #d4d4d4",
                          minWidth: "5rem",
                          borderRadius: "0.6rem",
                        }}
                      >
                        <Grid container xs={4} sm={4} md={4} lg={4}>
                          <RemoveIcon
                            style={{
                     
                              height: "25px",
                              borderRadius: "0.3rem 0rem 0rem 0.3rem",
                              color:secondaryColor || TEXT_COLOR,
                              backgroundColor:primaryColor|| BUTTON_COLOR ,
                           
                            }}
                            onClick={() => removeItem(e?.item_variant[0]._id)}
                          />
                        </Grid>
                        <Grid xs={4} sm={4} md={4} lg={4}>
                 
                          <Typography >
                        <span style={{fontSize:"1.1rem"}}>
                        {e?.quantity || 0} 
                        </span>
                    
                    </Typography>
                        </Grid>
                        <Grid
                          container
                          justifyContent="flex-end"
                          xs={4}
                          sm={4}
                          md={4}
                          lg={4}
                        >
                          <AddIcon
                            style={{
                              height: "25px",
                              color:secondaryColor || TEXT_COLOR,
                              backgroundColor:primaryColor|| BUTTON_COLOR ,
                           
                              borderRadius: "0rem 0.3rem 0.3rem 0rem",
                            }}
                            onClick={() => addItem(e?.item_variant[0]._id)}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                </Grid>
              </>
            );
          })) ||
          ""} */}
      </Grid>
    </>
  );
}
